import React, { useEffect, memo } from 'react';
import { Loader } from '../../loader/index';
import MskuInfoTable from './mskuInfoTable';
import MskuVolumeDataTable from './mskuVolumeDataTable';
import MskuGrowthDataTable from './mskuGrowthDataTable';
import MskuCagrDataTable from './mskuCagrDataTable';
import './demandPlannerYoySec.scss';

const DemandPlannerYoySec = memo((props) => {

    useEffect(() => {
        props.fetchDemandPlannerSecYoy();
    },
        //eslint-disable-next-line
        [])


    if (props.isDemandPlannerSecYoyLoading) {
        return (
            <Loader flag={true} />
        )
    }
    else {
        return (
            <div className='demand-planner-yoy-tables-container-main'>

                {
                    props.data &&
                    <div className='demand-planner-yoy-tables-container'>

                        <MskuInfoTable
                            data={props.data && props.data}
                        />

                        <MskuVolumeDataTable
                            data={props.data && props.data}
                            objKey='YearTotal'
                            heading='FULL YEAR VOLUMES'
                        />

                        <MskuGrowthDataTable
                            data={props.data && props.data}
                            objKey='YearGrowth'
                            heading='FULL YEAR GROWTH'
                        />

                        <MskuCagrDataTable
                            data={props.data && props.data}
                            objKey='Cagr'
                        />

                        <MskuVolumeDataTable
                            data={props.data && props.data}
                            objKey='Q1'
                            heading='Q1 VOLUMES'
                        />

                        <MskuGrowthDataTable
                            data={props.data && props.data}
                            objKey='Q1Growth'
                            heading='Q1 GROWTH'
                        />

                        <MskuVolumeDataTable
                            data={props.data && props.data}
                            objKey='Q2'
                            heading='Q2 VOLUMES'
                        />

                        <MskuGrowthDataTable
                            data={props.data && props.data}
                            objKey='Q2Growth'
                            heading='Q2 GROWTH'
                        />

                        <MskuVolumeDataTable
                            data={props.data && props.data}
                            objKey='Q3'
                            heading='Q3 VOLUMES'
                        />

                        <MskuGrowthDataTable
                            data={props.data && props.data}
                            objKey='Q3Growth'
                            heading='Q3 GROWTH'
                        />

                        <MskuVolumeDataTable
                            data={props.data && props.data}
                            objKey='Q4'
                            heading='Q4 VOLUMES'
                        />

                        <MskuGrowthDataTable
                            data={props.data && props.data}
                            objKey='Q4Growth'
                            heading='Q4 GROWTH'
                        />

                        <MskuGrowthDataTable
                            data={props.data && props.data}
                            objKey='Contribution'
                            heading='CONTRIBUTION'
                        />

                    </div>
                }

            </div>
        );
    }
})

export default DemandPlannerYoySec;